import { useEffect, useRef, useState } from 'react';

export const useMeasuredHeight = (enabled: boolean, dependencies: number[]) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (!enabled || !ref.current) {
            return undefined;
        }

        const updateHeight = () => {
            setHeight(ref.current?.scrollHeight || 0);
        };

        updateHeight();

        let resizeObserver: ResizeObserver | undefined;

        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(updateHeight);
            resizeObserver.observe(ref.current);
        }

        window.addEventListener('resize', updateHeight);

        return () => {
            resizeObserver?.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, [enabled, ...dependencies]);

    return { ref, height };
};
